'use client';

export default function Error() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1rem',
        justifyContent: 'center',
        height: '100vh',
      }}
    >
      <h1 style={{ color: 'var(--color-fg)', margin: 0 }}>Temporarily unavailable</h1>
      <p style={{ color: 'var(--color-fgMuted)', margin: 0 }}>
        We&apos;re looking into it and expect our usual service to return soon.
      </p>
      <a href="/" style={{ color: 'var(--color-bgPrimary)' }}>
        Go home
      </a>
    </div>
  );
}
